var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-form-model',{key:_vm.keyChange,ref:"ruleForm",staticStyle:{"margin-top":"10px"},attrs:{"model":_vm.form,"label-col":_vm.labelCol,"wrapper-col":_vm.wrapperCol,"rules":_vm.rules}},[_c('a-form-model-item',{attrs:{"label":"Name / Tên nhóm","prop":"name"}},[_c('a-input',{attrs:{"placeholder":"Write name..."},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_c('div',{style:({
      position: 'absolute',
      right: 0,
      bottom: 0,
      width: '100%',
      borderTop: '1px solid #e9e9e9',
      padding: '10px 16px',
      background: '#fff',
      textAlign: 'right',
      zIndex: 1,
    })},[_c('a-button',{staticStyle:{"margin-right":"10px"},on:{"click":_vm.close}},[_vm._v(" Close ")]),_c('a-button',{attrs:{"type":"primary","loading":_vm.loading},on:{"click":_vm.onSubmit}},[_vm._v(" Add New ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }